module.exports = __webpack_public_path__ + "img/ctrl-glu.dcc73e74.png";